export const LoadingStatus = {
    IDLE:       'idle',
    PENDING:    'pending',
    SUCCEEDED:  'succeeded',
    FAILED:     'failed'
};

export const isLoading  = (status) => status === LoadingStatus.PENDING;
export const isLoaded   = (status) => status === LoadingStatus.SUCCEEDED || status === LoadingStatus.FAILED;
export const isFailed   = (status) => status === LoadingStatus.FAILED;
export const isSuccess  = (status) => status === LoadingStatus.SUCCEEDED;